import React from 'react';
import '../styles/WorkSlider.css';
import Work from './Work';

export default function WorksSlider({ data }) {
    return (
        <div className='slider' style={{ background: 'transparent' }}>
            <div className="row">
                {
                    data.map(work => {
                        return (
                            <Work key={work.id} name={work.name} type={work.type} technologies={work.technologies} image={work.image} url={work.link}></Work>
                        )
                    })
                }
            </div>
        </div>
    );
};